export const ANESTHESIOLOGIST_INTENSIVIST_ACTIVITY_AREA_SELECTION =
  'ANESTHESIOLOGIST_INTENSIVIST_ACTIVITY_AREA_SELECTION';
export const ANESTHESIOLOGIST_ACTIVITY_AREA_SELECTION = 'ANESTHESIOLOGIST_ACTIVITY_AREA_SELECTION';
export const INTERNIST_ACTIVITY_AREA_SELECTION = 'INTERNIST_ACTIVITY_AREA_SELECTION';
export const MIXTE_ACTIVITY_AREA_SELECTION = 'MIXTE_ACTIVITY_AREA_SELECTION';
